export const generatedLiveSmallBodyReviewQueue = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-22T00:00:00.000Z",
  "mode": "deterministic-live-small-body-review-queue",
  "operatingRule": "Live CAD/SBDB geometry candidates can be queued for source review, but every resource, feedstock, or customer-facing conclusion stays blocked until object-specific orbit, observation, composition, archive, and source-use evidence is attached.",
  "sourceCandidateLedgerHash": "sha256-ee609d008f0470c727ad738d35e9787a186b9e6c3d1fc92f4e37b74e2e1b28cd",
  "sourceCandidatePayloadState": "live-capture-review-candidate",
  "captureArtifactHash": "sha256-2ad162480cc48a0874105a289f1df9732e325c92f043f7f9d1ba379bb8f37d98",
  "captureState": "pending-review",
  "queueState": "review-required",
  "reviewCandidateCount": 10,
  "blockedReviewCandidateCount": 10,
  "promotionAllowed": false,
  "resourcePromotionAllowed": false,
  "customerUseAllowed": false,
  "sourceUseReviewRequired": true,
  "requiredEvidenceTypes": [
    {
      "id": "sbdb-orbit-record",
      "label": "SBDB object, orbit, and physical-property record",
      "sourceIds": [
        "sbdb-api"
      ],
      "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
      "acceptedSourceRefs": [
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "sourceType": "small-body-orbit-api",
          "recordHash": "fnv1a32-93c0fe91",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
          "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
        }
      ]
    },
    {
      "id": "mpc-observation-bridge",
      "label": "MPC observation/designation bridge",
      "sourceIds": [
        "mpc"
      ],
      "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
      "acceptedSourceRefs": [
        {
          "sourceId": "mpc",
          "title": "Minor Planet Center Data",
          "trust": "primary",
          "sourceType": "small-body-observation-archive",
          "recordHash": "fnv1a32-62694497",
          "url": "https://minorplanetcenter.net/data",
          "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
        }
      ]
    },
    {
      "id": "taxonomy-spectra-record",
      "label": "Taxonomy or spectra record",
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
      "acceptedSourceRefs": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "trust": "primary",
          "sourceType": "planetary-mission-archive",
          "recordHash": "fnv1a32-5c0abe4d",
          "url": "https://archives.esac.esa.int/psa/",
          "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "trust": "primary",
          "sourceType": "space-science-archive",
          "recordHash": "fnv1a32-e07b656d",
          "url": "https://darts.isas.jaxa.jp/",
          "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Dataset calibration and archive release notes."
        }
      ]
    },
    {
      "id": "mission-or-archive-product",
      "label": "Mission/archive product",
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
      "acceptedSourceRefs": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "trust": "primary",
          "sourceType": "planetary-mission-archive",
          "recordHash": "fnv1a32-5c0abe4d",
          "url": "https://archives.esac.esa.int/psa/",
          "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "trust": "primary",
          "sourceType": "space-science-archive",
          "recordHash": "fnv1a32-e07b656d",
          "url": "https://darts.isas.jaxa.jp/",
          "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Dataset calibration and archive release notes."
        }
      ]
    },
    {
      "id": "source-use-clearance",
      "label": "Commercial source-use clearance",
      "sourceIds": [
        "cad-api",
        "sbdb-api",
        "mpc",
        "pds"
      ],
      "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
      "acceptedSourceRefs": [
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "trust": "primary",
          "sourceType": "close-approach-api",
          "recordHash": "fnv1a32-ba0c45bb",
          "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
          "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
        },
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "sourceType": "small-body-orbit-api",
          "recordHash": "fnv1a32-93c0fe91",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
          "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
        },
        {
          "sourceId": "mpc",
          "title": "Minor Planet Center Data",
          "trust": "primary",
          "sourceType": "small-body-observation-archive",
          "recordHash": "fnv1a32-62694497",
          "url": "https://minorplanetcenter.net/data",
          "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "license": "Public-source review required before redistribution of raw payloads.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        }
      ]
    }
  ],
  "evidenceHashes": {
    "sourceCandidateLedger": "sha256-ee609d008f0470c727ad738d35e9787a186b9e6c3d1fc92f4e37b74e2e1b28cd",
    "sourceCandidateNormalizedRecord": "sha256-6d060936f986102b7f1966d4c7b292dfdb2d8ebefe27569316051540e53f3857",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "requiredEvidenceTypes": "sha256-236567e36d83f699fd9472257f76946c0d4ec4236d2598292f15d36b341fdca3",
    "reviewCandidateInputs": "sha256-4cbf74397a995bb7b9d64be811191dc80c6194e4c6e5ed98f7f20c21d1016d08"
  },
  "reviewCandidates": [
    {
      "queueRank": 1,
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "name": "2026 JM2",
      "orbitId": "3",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-May-07 13:06",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000294100201228539,
        "distanceMinAu": 0.000293776751625198,
        "distanceMaxAu": 0.000294423602943003,
        "vRelativeKms": 5.82890597117675,
        "vInfinityKms": 3.98203598006233,
        "absoluteMagnitudeH": 32.69,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 34.83,
      "reviewPriorityScore": 52.39,
      "candidateHash": "sha256-aaaca64ffad06f47149a8a993805f10145da065984eb52c522b5d98043e3cfc2",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-ff8be8d35a07b67b4550c97f41b449b1b514fb2e5394cd94e214d2ec3e2e0414"
    },
    {
      "queueRank": 2,
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "name": "2026 EM",
      "orbitId": "1",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-Mar-07 19:45",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000185275976173685,
        "distanceMinAu": 0.000185184792086907,
        "distanceMaxAu": 0.000185367140441376,
        "vRelativeKms": 8.18617169785708,
        "vInfinityKms": 6.18474991688406,
        "absoluteMagnitudeH": 31.52,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 24.44,
      "reviewPriorityScore": 44.28,
      "candidateHash": "sha256-4cc69d2d5b7a9f0819299bb3fadaf8fa6837b6390751faa8fd1ea8a309713ae3",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-6df16ec3513b4a4a5a7d33929b56531f5ef9e327ab08f8825a45055d5ffb10e8"
    },
    {
      "queueRank": 3,
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "name": "2026 DN5",
      "orbitId": "4",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-Feb-22 17:45",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000287726973376227,
        "distanceMinAu": 0.0002871949654878,
        "distanceMaxAu": 0.000288258436803427,
        "vRelativeKms": 8.60293606593264,
        "vInfinityKms": 7.44913567122022,
        "absoluteMagnitudeH": 30.91,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "00:01"
      },
      "geometryScore": 18.38,
      "reviewPriorityScore": 39.5,
      "candidateHash": "sha256-a25f00783f73361afb556cd6c49724c5d68b83b0135e59dd177ff6dde87c0f6a",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-93f5d32ad3ad3c944dc668e63f28c80041e50e0f29b1e64a9509439f84065257"
    },
    {
      "queueRank": 4,
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "name": "2026 LX",
      "orbitId": "7",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-Jun-07 09:38",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000551340888395364,
        "distanceMinAu": 0.000551151367955083,
        "distanceMaxAu": 0.000551530398177911,
        "vRelativeKms": 8.07230947248158,
        "vInfinityKms": 7.44961264842787,
        "absoluteMagnitudeH": 28.853,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 18.44,
      "reviewPriorityScore": 39.44,
      "candidateHash": "sha256-7d8d0bcec1b953ef32271ecb087c0e8c3308aa611abbfc45466ac5cc9dac775d",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-4fae6d7ab95b307f3f96ca27dff139af04a0cbaf9a16effba85536265ee1da88"
    },
    {
      "queueRank": 5,
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "name": "2026 KU1",
      "orbitId": "1",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-May-22 22:11",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000381800775136746,
        "distanceMinAu": 0.00038157399962291,
        "distanceMaxAu": 0.000382027534025604,
        "vRelativeKms": 9.04061226311878,
        "vInfinityKms": 8.23257172787733,
        "absoluteMagnitudeH": 31.07,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 14.73,
      "reviewPriorityScore": 36.59,
      "candidateHash": "sha256-c239b1bcd092750bc9e6a16707ffc3e73345d7a665a0f0cbdfbccc333e5ccc4e",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-bb42949fcb43e63090dc98812e3cf9328399eecf4930f24a37af20c3432d18e4"
    },
    {
      "queueRank": 6,
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "name": "2026 FS5",
      "orbitId": "1",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-Mar-22 11:40",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000308382401483998,
        "distanceMinAu": 0.000308080600714394,
        "distanceMaxAu": 0.000308684142058,
        "vRelativeKms": 10.791382031208,
        "vInfinityKms": 9.95859261736853,
        "absoluteMagnitudeH": 31.32,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 6.53,
      "reviewPriorityScore": 30.19,
      "candidateHash": "sha256-8e2d541a2ee819b441141956c87b74ee2ad79c03d4f747d154588f973c66c3f4",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-262b3c0c123aecc32d5f52520e2b31ad8c01569018eec9b76102c02d1ca4f462"
    },
    {
      "queueRank": 7,
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "name": "2026 ET3",
      "orbitId": "1",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-Mar-15 04:01",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.0003520371549018,
        "distanceMinAu": 0.000351523241049475,
        "distanceMaxAu": 0.000352551004040026,
        "vRelativeKms": 11.7529241924732,
        "vInfinityKms": 11.0902541784934,
        "absoluteMagnitudeH": 29.84,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 1.17,
      "reviewPriorityScore": 25.97,
      "candidateHash": "sha256-95c6c43ac317ae7036e5b865031ad57212f2cb625b1045de9e8fcf85933c70d3",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-5676e519235ace6321525f16de26da0f390572a55b5af69ab88d044c14000ba9"
    },
    {
      "queueRank": 8,
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "name": "2026 JN4",
      "orbitId": "3",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-May-15 13:44",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.0000135393094047249,
        "distanceMinAu": 0.00000375170579701919,
        "distanceMaxAu": 0.0000253077902814512,
        "vRelativeKms": 23.1929310794925,
        "vInfinityKms": 12.0133440581274,
        "absoluteMagnitudeH": 33.38,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "00:06"
      },
      "geometryScore": 0,
      "reviewPriorityScore": 24.65,
      "candidateHash": "sha256-5d3f5d4f563380f497cb409a8a58662a36c48e82ae0991169dcf01974bb2462b",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-48da4867c6ac9c46c738465c95efbe5f128ceaa4b478bff078b848c674721730"
    },
    {
      "queueRank": 9,
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "name": "2026 JV3",
      "orbitId": "2",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-May-14 22:59",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000335097959791211,
        "distanceMinAu": 0.000334863897147954,
        "distanceMaxAu": 0.000335332004167003,
        "vRelativeKms": 12.6898619540927,
        "vInfinityKms": 12.0469874783314,
        "absoluteMagnitudeH": 30.49,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 0,
      "reviewPriorityScore": 24.51,
      "candidateHash": "sha256-ecf65363587dbbc32114d0d8092e8ca2744789de0a273a60c5272844ea329ebb",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-dcf223265df17e3c21e6e7190cf315bd5b35b12c434dec5bcbbb1c831b390ef1"
    },
    {
      "queueRank": 10,
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "name": "2026 HZ4",
      "orbitId": "1",
      "sourceRecordType": "cad-close-approach-record",
      "evidenceState": "geometry-screen-only",
      "reviewState": "pending-human-source-review",
      "bestCloseApproachDate": "2026-Apr-24 12:13",
      "closeApproachCount": 1,
      "approachRowCount": 1,
      "values": {
        "distanceAu": 0.000198589377334507,
        "distanceMinAu": 0.000196459289039482,
        "distanceMaxAu": 0.000200712651675717,
        "vRelativeKms": 13.2661785245408,
        "vInfinityKms": 12.2130027273613,
        "absoluteMagnitudeH": 29.75,
        "diameterKm": null,
        "diameterSigmaKm": null,
        "timeSigma": "< 00:01"
      },
      "geometryScore": 0,
      "reviewPriorityScore": 24.43,
      "candidateHash": "sha256-0c9622e281041537b7740c53f7b860ac6e75d072a32be12603d7e746a931722f",
      "requiredEvidence": [
        {
          "id": "sbdb-orbit-record",
          "label": "SBDB object, orbit, and physical-property record",
          "sourceIds": [
            "sbdb-api"
          ],
          "requiredFor": "Confirm object identity, orbit solution, condition metadata, H magnitude, diameter fields, and physical-property provenance.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "id": "mpc-observation-bridge",
          "label": "MPC observation/designation bridge",
          "sourceIds": [
            "mpc"
          ],
          "requiredFor": "Trace designation lineage, observation arc, and orbit-confidence context before ranking for operational follow-up.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "id": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Support any resource-class hypothesis; CAD/SBDB geometry alone cannot identify composition.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "mission-or-archive-product",
          "label": "Mission/archive product",
          "sourceIds": [
            "pds",
            "esa-psa",
            "jaxa-darts"
          ],
          "requiredFor": "Attach independent archive or mission evidence before any material, feedstock, or customer-facing resource statement.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "id": "source-use-clearance",
          "label": "Commercial source-use clearance",
          "sourceIds": [
            "cad-api",
            "sbdb-api",
            "mpc",
            "pds"
          ],
          "requiredFor": "Confirm license, attribution, redistribution, and downstream customer-use boundaries for each promoted record.",
          "attachedSourceIds": [],
          "satisfied": false,
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            },
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            },
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "license": "Public-source review required before redistribution of raw payloads.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "state": "blocked-for-resource-composition-and-source-review",
        "allowedUse": "May prioritize follow-up source intake, reviewer assignment, and trajectory screening only. It may not support a feedstock, resource, or customer conclusion.",
        "blockers": [
          "Live CAD/SBDB capture is pending reviewer approval.",
          "Object-specific SBDB/MPC identity and orbit context must be attached.",
          "Taxonomy, spectra, or mission/archive evidence is required before composition can promote.",
          "Commercial source-use clearance is required before customer-facing export."
        ]
      },
      "reviewCandidateHash": "sha256-f1bdd8e189aa9bd704d710f762dccc7b77d390bb1623eced763b3a99c4369bbe"
    }
  ],
  "queueHash": "sha256-5c15135920e0213d2fe953e13a47ef1fdd410b577ff30f5c9d7c49fea2a8089f",
  "byteLength": 92520
}
;
